/** @namespace UI.Renderer */
NS("UI.Renderer");
/**
 * @class
 */
UI.Renderer.Base = new Static( /** @lends UI.Renderer.Base */ {
    prefix: '',
    path: 'templates/',
    urlArgs: '',

    initialize: function() {
        this.prefix = GLOBAL.RENDERER_PREFIX || this.prefix;
        this.path = GLOBAL.RENDERER_PATH || this.path;
        this.urlArgs = GLOBAL.RENDERER_URL_ARGS || this.urlArgs;
    },

    init: function() {},

    render: function(name, args) {
        return "";
    }
});
